import { OFFSCREEN_X, OFFSCREEN_Y } from "../Constants";
import * as d3 from "d3";

export default class Centroid {
	constructor(type="centroid", key, x, y) {
		this.type = type;
		this.key = key;
		this.x = x;
		this.y = y;
		this.labels = document.createDocumentFragment();
		const s = document.createElement('span');
		s.setAttribute('class', `label`);
		s.setAttribute('style', `top:${12}px`);
		s.setAttribute('data-top', `${12.0}`);
		// add an empty label to the overlay to keep the label resizing mechanism working properly. There's a better way to do this
		this.labels.appendChild(s);
		this.x_force = d3.forceX( d => {
			if (d.iso == this.key) {
				d.scale.set(.75);
			}
			return d.iso == this.key ? this.x : OFFSCREEN_X;
		}).strength(0);
		this.y_force = d3.forceY( d => { return d.iso == this.key ? this.y : OFFSCREEN_Y }).strength(0);
	}
}
